import { render, staticRenderFns } from "./Viewpoints.vue?vue&type=template&id=5d6771b6"
import script from "./Viewpoints.vue?vue&type=script&lang=js"
export * from "./Viewpoints.vue?vue&type=script&lang=js"
import style0 from "./Viewpoints.vue?vue&type=style&index=0&id=5d6771b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports